const threshold_types = {
    "STATIC": "Static",
    "DYNAMIC": "Dynamic",
    'SERVICE_QUOTA': "ServiceQuota"
}

const team_values = {
    "UNMAPPED": "unmapped"
}

const monitoring_systems = {
    "AWS": "Amazon Web Services",
    "GCP": "Google Cloud Platform",
    "NewRelic": "New Relic",
    "Datadog": "Datadog",
    'Azure': 'Microsoft Azure',
    "AppDynamics": "App Dynamics",
    "Splunk": "Splunk",
    "Dynatrace": "Dynatrace",
    "OCI": "Oracle Cloud Infrastructure",
    "Grafana": "Grafana",
    "Signoz": "Signoz",
}

const service_names = {
    "AWS_EKS_SERVICE": "AWS/EKS/Service",
    "AWS_EKS": "AWS/EKS"
}

const notification_channel_names = {
    "MS_TEAMS": "Microsoft Teams"
}

const datadog_resources = {
    "SYNTHETIC": "datadog_synthetics",
    "REGISTERED_ENDPOINT": "registered_api_endpoint"
}

const datadog_metrics = {
    "SYNTHETIC_METRIC": "Synthetic Metric"
}

export {
    threshold_types,
    team_values,
    monitoring_systems,
    service_names,
    notification_channel_names,
    datadog_resources,
    datadog_metrics
}
